export interface ProcessEntity {
  processId: number
  typeProcessId: number
  typeProcessName?: string
  fileName: string
  mimeType: string | null
  urlFile: string
  statusId: number
  fileNameResulting: string
  mimeTypeResulting: string | null
  urlFileResulting: string
  createDate: string
  startDate: string | null
  endDate: string | null
  urlProcess: string | null
  data: string
  userId: number
  userName: string
}

export type CustomActionsProps = {
  id: number
  row: ProcessEntity
}

export enum ProcessStatus {
  Created = 1,
  InProcess = 2,
  Finalized = 3,
  WithError = 4
}
